import React, { useEffect, useState } from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";

import DetailInfoComponent from "../../../components/detailInfo/detailInfoComponent";
import { SectionModel } from "../../../models/components.model";
import { ChequeGuarantyInfo } from "../../../models/loan.model";
import DocumentInfoComponent from "../../../components/detailInfo/documentInfoComponent";
import { ErrorsTab, GetCoreInformationResponse, InfoCheque, ReferenceKey } from "../../../models/cartable.model";
import DocumentInfoComponentSingle from "../../../components/detailInfo/documentInfoComponentSingle";
import * as Converter from "persian-currency-converter";
import Grid from "@mui/material/Grid";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useMutation } from "react-query";
import { GetCoreInformation } from "../../../services/cartable.service";
import { toast } from "react-toastify";
import { ApiResultModel } from "../../../models/common.model";
import Axios from "axios";
import { ApiBaseUrl } from "../../../config/config";
import ShowErrorsModal from "../../../components/modals/ShowErrorModal";

export default function WorkflowInfo(props: any) {
    let data = props.data;
    let errorTempArray = [] as ErrorsTab[];
    const [openModal, setOpenModal] = React.useState(false);
    const [workflowStepType, setWorkflowStepType] = React.useState();
    const [error, setError] = React.useState([] as ErrorsTab[]);
    const handleShowError = (getData: any) => {
        if (getData.userData.length > 0) {
            getData.userData.map((item: any) => {
                let errortemp = { errorsHeader: item.key, errorMessages: item.value }
                errorTempArray.push(errortemp);
                setError(errorTempArray);
                setWorkflowStepType(getData.workflowStepType);
            })
            setOpenModal(true);
        }
    }
    return (
        <>
            <Grid item xs={12} style={{ marginTop: "1.5vh" }}>
                <div
                    className="cardTableBorder"
                    style={{ minHeight: "30vh" }}
                >
                    <TableContainer style={{ background: "#fff" }}>
                        <Table
                            stickyHeader
                            aria-label="sticky table"
                            style={{ borderCollapse: "collapse" }}
                        >
                            <TableHead
                                className="rowTHead"
                                style={{ paddingBottom: "10px" }}
                            >
                                <TableRow className="borderRight borderLeft">
                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="right"
                                        style={{ width: "10vh", minWidth: "10vh" }}
                                    >
                                        ردیف
                                    </TableCell>
                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="center"
                                    >
                                        کاربر
                                    </TableCell>

                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="center"
                                    >
                                        تاریخ عملیات
                                    </TableCell>
                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="center"
                                    >
                                        گردش کار
                                    </TableCell>
                                    <TableCell
                                        className="rowTHead colorTitle textFont14 "
                                        align="center"
                                    >
                                        نوع عملیات
                                    </TableCell>
                                    <TableCell className="rowTHead colorTitle textFont14 " align="right">
                                        <MoreHorizIcon
                                            scale="scale(1.8) "
                                            style={{ color: "#1D4A87" }}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <div
                                style={{ width: "100%", height: "10px" }}
                            ></div>
                            <TableBody>
                                {/* {initialValues.items?.map((row: any, rowIndex: any) => { */}
                                {data?.map((row: any, rowIndex: any) => {
                                    return (
                                        <TableRow
                                            className={`${rowIndex % 2 == 0
                                                ? "rowTBodyE  borderRight borderLeft"
                                                : "rowTBodyO  borderRight borderLeft"
                                                }`}
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.value}
                                        >
                                            <TableCell className="textFont12">
                                                {
                                                    rowIndex +
                                                    1}
                                            </TableCell>
                                            <TableCell
                                                className="textFont12 nowrapClass"
                                                align="right"
                                            >
                                                <span>{row.userTitle}</span>

                                            </TableCell>
                                            <TableCell
                                                className="textFont12 nowrapClass"
                                                align="right"
                                            >
                                                <span>{row.actionDatePersian}</span>
                                            </TableCell>
                                            <TableCell
                                                className="textFont12 nowrapClass"
                                                align="right"
                                            >
                                                <span>{row.workflowTypeTitle}</span>
                                            </TableCell>
                                            <TableCell
                                                className={`${row.workflowStepType == "Forward" ? "SuccessDefaultFont textFont12" : " DangerDefaultFont textFont12"}`}
                                                align="right"
                                            >
                                                <span>{row.actionTitle}</span>
                                            </TableCell>
                                            <TableCell>
                                                <MoreHorizIcon
                                                    scale="scale(1.8) "
                                                    className={`${row.userData.length > 0 ? " enableMoreHorizIcon cursorPointer" : " disableMoreHorizIcon "}`}
                                                    onClick={() => handleShowError(row)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <ShowErrorsModal
                        openModal={openModal}
                        setOpenModal={setOpenModal}
                        validationMessages={error}
                        workflowStepType={workflowStepType}
                    // firstPartOfTitle=" درخواست تسویه شما به دلایل زیر"
                    // boldTitle="رد درخواست"
                    // secondPartOfTitle="شده است" 
                    />
                </div>
            </Grid >
        </>
    );
    // <DocumentInfoComponentSingle data={props} />
}
